import { Middleware } from 'redux';
import { validateFormGroup } from './actions';
import { actionTypes } from 'redux-form';
export const asyncValidationMiddlware: Middleware = api => next => action => {
  if (action.type === actionTypes.BLUR) {
    const state = api.getState();
    const blurFieldId = action.meta.field;
    if (state.wizard.asyncGroups && state.wizard.asyncFields[blurFieldId]) {
      //check to see if blurred field was in one of the async groups
      const groupToValidate: AsyncGroup = state.wizard.asyncGroups.find(
        (group: AsyncGroup) => {
          return (
            group.fields.includes(blurFieldId) &&
            group.fields.every(
              (field: string) => state.form.formSchema.values[field]
            )
          );
        }
      );
      //if a group was found...
      if (groupToValidate) {
        //generate an object to be made into query params
        const paramObject = groupToValidate.fields.reduce(
          (acc: ObjectKeyStringKeyValues, field: string) => {
            acc[field] = state.form.formSchema.values[field];
            return acc;
          },
          {}
        );
        validateFormGroup(groupToValidate, paramObject, api.dispatch).then();
      }
    }
  }
  return next(action);
};
